import { ColoursObj } from '@eventr/common-storybook'
import { Box } from '@mui/material'

export const ChatCardSkeleton = () => {
    return (
        <Box
            sx={{
                padding: '12px',
                borderBottom: `1px solid ${ColoursObj.backgrounds.secondary}`,
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                height: '50px', // Match the height of a regular ChatCard
                animation: 'chatCardPulse 1.5s infinite ease-in-out',
                '@keyframes chatCardPulse': {
                    '0%': { opacity: 0.6 },
                    '50%': { opacity: 0.8 },
                    '100%': { opacity: 0.6 },
                },
            }}
        >
            {/* Circle for avatar */}
            <Box
                sx={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: ColoursObj.backgrounds.secondary,
                }}
            />

            {/* Lines for text */}
            <Box sx={{ flex: 1 }}>
                <Box
                    sx={{
                        height: '16px',
                        width: '70%',
                        backgroundColor: ColoursObj.backgrounds.secondary,
                        borderRadius: '4px',
                        marginBottom: '8px',
                    }}
                />
                <Box
                    sx={{
                        height: '12px',
                        width: '40%',
                        backgroundColor: ColoursObj.backgrounds.secondary,
                        borderRadius: '4px',
                    }}
                />
            </Box>
        </Box>
    )
}
